import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ProdSetProdRelList } from '@/md/entities/prodSetProd/ProdSetProdRelList';

export const ProdSetProdDetail = () => {
  const { entityObj } = useEntityMgr();

  // --- Tab Specifications ---
  const tabSpecs = [
    { id: 'info', label: 'Info', content: <EntityForm /> },
    { id: 'prod', label: 'Products', content: <ProdSetProdRelList prodSetObj={entityObj} /> },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
